import React, { useEffect, useState } from 'react'
import './ToursGallery.sass'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import getCollection from '../../../utils/db/getCollection'
import { isEmpty, orderBy } from 'lodash'
import Carousel from '../../../ui/Carousel/Carousel'
import { NavLink, withRouter } from 'react-router-dom'
import parse from 'html-react-parser'
import regAnalyticReq from '../regAnalyticReq'

function ToursGallery({ ...router }) {
  const [tours, setTours] = useState(null)

  useEffect(() => {
    getCollection({
      path: 'tours',
      docIdName: 'id',
      whereQueries: [{ fieldPath: 'isPublished', op: '==', value: true }],
    }).then((data) => {
      setTours(orderBy(data, ['pos'], ['asc']))

      regAnalyticReq({
        projectId: 'bXy8m4F5kHXNU3ADr43Z',
        counterType: 'carousel',
        eventType: 'watch',
      })
        .then((r) => {
          console.log('🚀 ~ ToursGallery ~ r:', r)
        })
        .catch((e) => {
          console.log('🚀 ~ ToursGallery ~ e:', e)
        })
    })
  }, [])

  const onCarouselClicked = (id) => {
    regAnalyticReq({
      projectId: 'bXy8m4F5kHXNU3ADr43Z',
      counterType: 'carousel',
      offerType: 'tour',
      offerId: id,
      offerLink: `https://hotel.iterrainc.ru/tours/${id}`,
      eventType: 'click',
    })
      .then((r) => {
        console.log('🚀 ~ ToursGallery ~ r:', r)
      })
      .catch((e) => {
        console.log('🚀 ~ ToursGallery ~ e:', e)
      })

    router.history.push(`/tours/${id}`)
  }

  return (
    <div className="Api-ToursGallery">
      <div className="Api-ToursGallery-Container">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <SectionTitle title="Туры по Кольскому полуострову" />
              <div className="Api-ToursGallery-Carousel">
                {!isEmpty(tours) && (
                  <Carousel
                    element={`tour-gallery`}
                    options={{
                      type: 'carousel',
                      perView: 1,
                      ...(!isEmpty(tours) ? { autoplay: 5000 } : {}),
                      focusAt: 'center',
                      gap: -16,
                      peek: {
                        before: 250,
                        after: 250,
                      },
                      useDots: false,
                      useArrows: true,
                      breakpoints: {
                        576: {
                          gap: 0,
                          peek: { before: 0, after: 0 },
                        },
                      },
                    }}
                  >
                    {!isEmpty(tours)
                      ? tours.map((t) => (
                          <div
                            onClick={() => onCarouselClicked(t.id)}
                            className={'Api-TourGallery-Tile'}
                          >
                            <img
                              src={t.ru.photoLinks.split('\n')[0]}
                              alt={t.ru.title}
                            />
                            <div className="TitleBackground">
                              <p>{t.ru.title}</p>
                              {/* <p className="Description">
                                {parse(t.ru.descriptionShort)}
                              </p>
                              <div className="tButton">Подробнее о туре</div> */}
                            </div>
                          </div>
                        ))
                      : null}
                  </Carousel>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(ToursGallery)
